import styled from 'styled-components';

export const BaseHead1 = styled.h1`
  font-size: ${(props) => props.theme.fontSizes.head1};
  /* line-height: ${(props) => props.theme.lineHeights.head1}; */
`;

export const BaseHead2 = styled.h2`
  font-size: ${(props) => props.theme.fontSizes.head2};
  /* line-height: ${(props) => props.theme.lineHeights.head2}; */
`;

export const BaseHead4 = styled.h4`
  font-size: ${(props) => props.theme.fontSizes.body3};
  /* line-height: ${(props) => props.theme.lineHeights.body1}; */
`;

export const BaseBody1 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body1};
  /* line-height: ${(props) => props.theme.lineHeights.body1}; */
`;

export const BaseBody2 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body2};
  /* line-height: ${(props) => props.theme.lineHeights.body2}; */
`;

export const BaseBody3 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body3};
  /* line-height: ${(props) => props.theme.lineHeights.body3}; */
`;

export const BaseBody4 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body4};
  /* line-height: ${(props) => props.theme.lineHeights.body4}; */
`;

export const BaseBody5 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body5};
  /* line-height: ${(props) => props.theme.lineHeights.body5}; */
`;

export const BaseBody6 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.body6};
  /* line-height: ${(props) => props.theme.lineHeights.body6}; */
`;

export const BaseText1 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text1};
  /* line-height: ${(props) => props.theme.lineHeights.text1}; */
`;

export const BaseText2 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text2};
  /* line-height: ${(props) => props.theme.lineHeights.text2}; */
`;

export const BaseText3 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text3};
  /* line-height: ${(props) => props.theme.lineHeights.text3}; */
`;

export const BaseText4 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text4};
  /* line-height: ${(props) => props.theme.lineHeights.text4}; */
`;

export const BaseText5 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text5};
  /* line-height: ${(props) => props.theme.lineHeights.text5}; */
`;

export const BaseText6 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.text6};
  /* line-height: ${(props) => props.theme.lineHeights.text6}; */
`;

export const BaseMemoText = styled.p`
  font-size: ${(props) => props.theme.fontSizes.memoText};
  /* line-height: ${(props) => props.theme.lineHeights.memoText}; */
`;

export const BaseGnb1 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.gnb1};
  /* line-height: ${(props) => props.theme.lineHeights.gnb1}; */
`;

export const BaseGnb2 = styled.p`
  font-size: ${(props) => props.theme.fontSizes.gnb2};
  /* line-height: ${(props) => props.theme.lineHeights.gnb2}; */
`;

export const Basedate = styled.p`
  font-size: ${(props) => props.theme.fontSizes.date};
  /* line-height: ${(props) => props.theme.lineHeights.date}; */
`;
